import { Form } from "@components";
import React, { useState } from "react";
import { Category } from "../../../../../../store";
import { SystemType, getSystemTypes } from "@api";

interface Props {
  data: Category | undefined;
  onHandleChange: (key: any, any: any) => void;
  form: any;
  isEmptyBusinessUnit?: boolean;
}

type FormValues = {
  id: number;
  name: string;
  isActive: boolean;
  isManual: boolean;
  businessUnit: {
    id: number;
    name: string;
  };
};

type Key = keyof FormValues;

export const FormData: React.FC<Props> = ({
  data,
  onHandleChange,
  form,
  isEmptyBusinessUnit,
}) => {
  const [loading, setLoading] = useState(false);
  const [dataSystemType, setDataSystemType] = useState<
    { id: string; label: string; value: string }[]
  >([]);

  function handleBusinessUnitValueChange(
    name: "businessUnit",
    value: string
  ): void {
    const businessUnit = (dataSystemType || []).find(({ id }) => id === value);

    if (businessUnit) {
      onHandleChange(name, businessUnit);
    }
  }

  function getFormValue(key: keyof FormValues): string {
    const value = form.values[key];
    return (
      (typeof value === "string" ? value : value?.label || value?.name) || ""
    );
  }

  React.useEffect(() => {
    setLoading(true);
    getSystemTypes()
      .then((envResponse: SystemType[]) => {
        const dataResponse = (envResponse || []).map(
          (env: SystemType, index) => {
            return {
              id: `${env.id}`,
              value: `${env.id}`,
              label: `${env.name}`,
            };
          }
        );
        setDataSystemType(dataResponse);
        setLoading(false);
      })
      .catch((err: any) => {
        console.error("there was an errror fetching business unit: ", err);
      });
  }, []);

  return (
    <Form>
      <Form.Textbox
        label="System Category Name"
        name="name"
        onChange={onHandleChange}
        size={12}
        value={form.values.name}
        required
        error={form.errors.name}
        maxLength={80}
      />
      <Form.Dropdown
        error={form.errors.businessUnit}
        label="Business Unit"
        loading={loading}
        name="businessUnit"
        onChange={handleBusinessUnitValueChange}
        customStyle={isEmptyBusinessUnit ? { borderColor: "red" } : null}
        options={[{ label: "No Selection", value: "" }, ...dataSystemType]}
        required
        size={12}
        value={getFormValue("businessUnit") || ""}
      />
      <Form.Checkbox
        label="Is Manual"
        name="isManual"
        onChange={onHandleChange}
        size={12}
        value={form.values.isManual}
      />
      <Form.Checkbox
        label="Is Active"
        name="isActive"
        onChange={onHandleChange}
        size={12}
        value={form.values.isActive}
      />
    </Form>
  );
};
